import { render, staticRenderFns } from "./PanelRowItem.vue?vue&type=template&id=13539f91&scoped=true&"
import script from "./PanelRowItem.vue?vue&type=script&lang=js&"
export * from "./PanelRowItem.vue?vue&type=script&lang=js&"
import style0 from "./PanelRowItem.vue?vue&type=style&index=0&id=13539f91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13539f91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
